import { Record } from 'immutable';
import { schema } from 'normalizr';

export const WeeklySolarReport = new Record({
  id: undefined,
  consumed: undefined,
  generated: undefined,
  corrected: undefined,
  week_end_date: undefined,
  site: undefined,
});

export const weeklySolarReportSchema = new schema.Entity('weeklySolarReports');

// for reading in nested models, object with { field: schema }
// weeklySolarReportSchema.define({  });
